module.exports = __webpack_public_path__ + "img/wordpress_3.0ac0b8ca.png";